import { LOCALE_DICTIONARY } from '../../config/settings/constants'
import formatNumberRegex, { commasRegex, NUMBER_LAST_COMMA, NUMBER_LAST_POINT } from '../../config/settings/regex'

/**
 * Truncate string by n value
 */
export function truncate(str, n) {
  return str.length > n ? str.substr(0, n - 1) + '...' : str
}

/**
 * Convert the string into capitalize format
 */
export function capitalizer(str) {
  const lwrstr = str.toLowerCase()
  return lwrstr.charAt(0).toUpperCase() + lwrstr.slice(1)
}

/**
 * Turn into array strings separated by commas
 */
export function sliceString(str) {
  return str.split(commasRegex)
}

/**
 * Formats the given value with dots to commas.
 */
export const formatCommas = value => value.toString().replace(/\./, ',')

/**
 * Formats the given value to currency (xxx.xxx.xxx, ex: 1234 = 1.234).
 */
export const formatAmount = value => value?.toString().replace(formatNumberRegex, '$1.')

/**
 * Formats the given value to percentage (xxx.xxx.xxx, ex: 1234 = 1.234).
 */
export const formatPercentage = value => `${formatCommas(value)}%`

/**
 * Formats the given value to higher units (e.g. 1.000.000 to 1M).
 */
export const minFormatter = value => {
  switch (true) {
    case value > 1000 && value < 1000000: {
      return `${formatCommas((value / 1000).toFixed(2))}K`
    }
    case value >= 1000000 && value < 1000000000: {
      return `${formatCommas((value / 1000000).toFixed(2))}M`
    }
    case value >= 0 && value <= 1000: {
      return formatAmount(value)
    }
    case value >= 1000000000: {
      return `${formatCommas((value / 1000000000).toFixed(2))}MM`
    }
    default: {
      return ''
    }
  }
}

/**
 * Currency type format is controlled, using the Intl.NumberFormat object.
 * You have to pass the value and the type of currency,
 * the function returns the formatted value.
 */
export const formatCurrency = (value = 0, currency = 'CLP', currencyDisplay = undefined) => {
  if (value === 0 || value === '' || value === '0') return ''

  const isUSD = currency === 'USD'
  const regex = isUSD ? NUMBER_LAST_POINT : NUMBER_LAST_COMMA

  const updateValue = new Intl.NumberFormat(LOCALE_DICTIONARY[currency], {
    style: 'currency',
    currency,
    currencyDisplay
  }).format(value.toString().replace(regex, '').split(',').join('.'))

  if (updateValue.indexOf('NaN') > -1) {
    return ''
  }

  return updateValue
}

/**
 * function is designed to format numerical values with thousands separators (.) and a comma (,) as the decimal separator
 */
export const formatNumberAmount = (value, decimals = 2) => {
  return value
    .toFixed(decimals)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
